import axios from 'axios';
import { env } from 'env';
import { ICustomStyles } from '../interfaces';
import { IWorldSettings } from '@interfaces/worlds';

export default class WorldsService {
  static getCustomStyles(
    domainName: string,
  ): Promise<{ customStyles: ICustomStyles | null }> {
    return axios
      .get(`${env.REACT_APP_API_URL}api/v2/worlds/styles`, {
        params: { domainName },
      })
      .then((res: any) => res.data);
  }

  static getWorldSettings(
    domainName: string,
  ): Promise<{ settings: IWorldSettings | null }> {
    return axios
      .get(`${env.REACT_APP_API_URL}api/v2/worlds/settings`, {
        params: { domainName },
      })
      .then((res: any) => res.data);
  }
}
